import {Formik, Form, FormikHelpers} from 'formik'
import * as Yup from 'yup'
import {ClassBase} from './type'
import toast from 'react-hot-toast'
import {createClass, updateClass} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormikControl from '../../../components/formikControl/FormikControl'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

interface ClassFormProps {
  initialValues?: ClassBase
  onAfterSubmit: () => void
}

const formInitialValues: Omit<ClassBase, 'class_id'> = {
  class_name: '',
  class_status: '1',
}

const valdiationSchema: Yup.Schema<Omit<ClassBase, 'class_id'>> = Yup.object({
  class_name: Yup.string()
    .max(100, 'The Class name cannot exceed 100 characters')
    .required('Class Name is required'),
  class_status: Yup.string()
    .oneOf(['0', '1'], 'Class Status must be either "0" or "1"')
    .required('Class Status is required'),
})

function ClassForm({initialValues, onAfterSubmit}: ClassFormProps) {
  const formType = initialValues ? 'update' : 'add'

  const submitHandler = async (
    values: Omit<ClassBase, 'class_id'> | ClassBase,
    {setSubmitting}: FormikHelpers<any>
  ) => {
    const toastId = toast.loading('Submitting')
    const action = formType === 'add' ? createClass : updateClass

    try {
      await action(values as any)
      toast.success('Success', {id: toastId})
      onAfterSubmit()
    } catch (err: any) {
      handleApiError(err, toastId)
    } finally {
      setSubmitting(false)
    }
  }

  const formValues = initialValues || formInitialValues
  return (
    <div className="px-5 py-3">
      <Formik<Omit<ClassBase, 'class_id'>>
        initialValues={formValues}
        validationSchema={valdiationSchema}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              required
              placeholder="Class Name"
              label="Class Name"
              name="class_name"
            />
            <FormikControl
              control="check"
              type="radio"
              options={[
                {key: 'Active', value: '1'},
                {key: 'Inactive', value: '0'},
              ]}
              required
              placeholder="Active Status"
              label="Active Status"
              name="class_status"
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default ClassForm
